export function TrustChips() {
  return (
    <div className="flex items-center justify-center gap-2">
      <span className="lume-chip">
        <span className="text-accent">★</span> 4.8 / 5
      </span>
      <span className="lume-chip">🔒 Private</span>
      <span className="lume-chip">👤 47k scans</span>
    </div>
  );
}
